import { render, staticRenderFns } from "./StudyBuddyTrigger.vue?vue&type=template&id=0c01ec82&scoped=true"
import script from "./StudyBuddyTrigger.vue?vue&type=script&lang=ts"
export * from "./StudyBuddyTrigger.vue?vue&type=script&lang=ts"
import style0 from "./StudyBuddyTrigger.vue?vue&type=style&index=0&id=0c01ec82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01ec82",
  null
  
)

export default component.exports